export const ENTER_CTA_LINK = '/choose-your-plan';
export const ENTER_FLOW_FIRST_STEP = '/enternow/1';
